import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Theme, makeStyles } from '@material-ui/core/styles';

export interface ITooltipProps {
    title: string | React.ReactChild;
    children: React.ReactElement;
    disabled?: boolean;
    placement?:
        | 'bottom'
        | 'bottom-end'
        | 'bottom-start'
        | 'top'
        | 'top-end'
        | 'top-start'
        | 'left'
        | 'left-end'
        | 'left-start'
        | 'right'
        | 'right-end'
        | 'right-start';
}

const useTriggersTooltipStyles = makeStyles((theme: Theme) => ({
    arrow: {
        color: '#2D3A59',
    },
    tooltip: {
        backgroundColor: 'rgba(45, 58, 89, 0.85)',
        borderRadius: '10px',
        transform: 'matrix(-1, 0, 0, 1, 0, 0)',
        width: '16.625rem',
        height: 'auto',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        fontStyle: 'normal',
        fontWeight: 'normal',
        padding: '0.9375rem 1.25rem',
        margin: '0!important',
        backdropFilter: 'blur(5px)',
    },
}));
export function TriggersTooltips({ title, children, disabled, placement }: ITooltipProps) {
    const [open, setOpen] = React.useState(false);
    const classes = useTriggersTooltipStyles();
    const handleTooltipClose = (e: any) => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
                PopperProps={{
                    disablePortal: true,
                }}
                onClose={handleTooltipClose}
                open={open}
                // disableFocusListener
                // disableHoverListener
                disableTouchListener
                title={title}
                classes={classes}
                placement={placement ?? 'top-start'}
            >
                <div
                    onClick={() => {
                        disabled && handleTooltipOpen();
                    }}
                    style={{ height: '100%' }}
                >
                    {children}
                </div>
            </Tooltip>
        </ClickAwayListener>
    );
}
